import { Loader } from 'semantic-ui-react';

import { useDebounce } from 'hooks';

type Props = {
  text?: string;
  isFetching?: boolean;
};

export const DebouncedFullScreenLoader = ({ text, isFetching }: Props) => {
  const showLoader = useDebounce(250);
  return showLoader && (isFetching ?? true) ? (
    <div>
      <Loader active size="big">
        {text ?? 'Loading...'}
      </Loader>
    </div>
  ) : null;
};
